import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ProponenteService, ContratoService } from 'administrativo-lib';
import {
  BaseResourceItemsComponent,
  ContratoRemanejo,
  ContratoRemanejoItem,
  DateFormatPipe,
  FuncaoService,
  GlobalService,
  Licitacao
} from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { ContratoRemanejoService } from '../../contrato/service/contrato-remanejo.service';

declare var $: any;

@Component({
  selector: 'lib-licitacao-remanejo',
  templateUrl: './licitacao-remanejo.component.html'
})
export class LicitacaoRemanejoComponent extends BaseResourceItemsComponent<ContratoRemanejo> {

  public ptBR: any;
  public itemAtual: ContratoRemanejo;
  public visualizar_item: boolean;
  public listaRemanejo: ContratoRemanejo[] = [];

  @Input() public licitacao: Licitacao;
  @Input() visualizarC: Boolean = false;
  @Output() licitacaoChange: EventEmitter<Licitacao> = new EventEmitter<Licitacao>();

  constructor(
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    public proponenteService: ProponenteService,
    public contratoService: ContratoService,
    public remanejoService: ContratoRemanejoService) {
    super(new ContratoRemanejo(), remanejoService);
  }

  protected afterInit(): void {
    this.ptBR = this.globalService.obterDataBR();
  }

  protected validSave(item: ContratoRemanejo): boolean {
    if (!item.data_contabilizacao && !this.login.parametro['licitacao']?.contratos_inativos) {
      toastr.warning(`Informe a data de contabilização do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.data_remanejo) {
      toastr.warning(`Informe a data do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.especie) {
      toastr.warning(`Informe a espécie do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.motivo) {
      toastr.warning(`Informe o motivo do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (item.data_contabilizacao && !this.funcaoService.podeAlterarAudesp(item.data_contabilizacao, this.login)) {
      toastr.warning(`Não é possível alterar o remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}. Prazo esgotado!`);
      return false;
    }
    return true;
  }

  protected beforeSave(item: ContratoRemanejo): void { }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public async adicionar() {
    this.visualizar_item = false;
    this.itemAtual = null;
    this.listaRemanejo = [];

    this.contratoService.obterPorLicitacao(this.licitacao.id, this.login.orgao.id).pipe(takeUntil(this.unsubscribe))
      .subscribe((resContratos) => {
        const contratos = resContratos?.content?.length ? resContratos.content : (this.licitacao.contratos || []);

        this.proponenteService.obterPorLicitacao(this.licitacao.id, false).pipe(takeUntil(this.unsubscribe))
          .subscribe((res) => {
            if (res.content?.length) {
              for (const prop of res.content) {
                // Tenta buscar o contrato do proponente pelo favorecido.id (comparacao nao restrita)
                const contratoDoProp = contratos.find(c => (c.favorecido?.id == prop.favorecido?.id) && !c.excluido);

                let remanejoNovo = new ContratoRemanejo();
                remanejoNovo.data_remanejo = this.funcaoService.obterDataUTC(new Date());
                const inativoPorPadrao = this.login.parametro['licitacao']?.contratos_inativos;

                if (contratoDoProp) {
                  // Se o contrato já existe, respeita o status dele:
                  // Se for ativo (!inativo), DEVE ter data. Se for inativo, fica nulo.
                  if (!contratoDoProp.inativo) {
                    remanejoNovo.data_contabilizacao = this.funcaoService.gerarUltimoDiaMesSeguinteAudesp(this.login.ultimoAudesp);
                  } else {
                    remanejoNovo.data_contabilizacao = null;
                  }
                } else {
                  // Se não existe contrato ainda, respeita o parâmetro
                  remanejoNovo.data_contabilizacao = inativoPorPadrao
                    ? null
                    : this.funcaoService.gerarUltimoDiaMesSeguinteAudesp(this.login.ultimoAudesp);
                }
                remanejoNovo.licitacao = this.licitacao;
                if (contratoDoProp) {
                  remanejoNovo.contrato = contratoDoProp;
                }
                remanejoNovo.usuario = this.login.usuario;
                remanejoNovo.exercicio = this.login.exercicio;
                remanejoNovo.proponente = prop;
                remanejoNovo.editavel = true;
                remanejoNovo.especie = 'R';
                remanejoNovo.valor_total = 0;
                remanejoNovo.itens = [];

                for (const item of this.licitacao.itens) {
                  // if (contratoDoProp) {
                    // Procura o item do contrato correspondente
                    // const ciMatch = contratoDoProp.itens?.find(ci => ci.memorial?.id === item.id || ci.produto_unidade?.id === item.produto_unidade?.id);
                    // if (ciMatch) {
                      // remanejoNovo.itens.push({
                        // quantidade: 0,
                        // saldo: item['saldo_qtd'] !== undefined ? item['saldo_qtd'] : (ciMatch['saldo_qtd'] || ciMatch.quantidade),
                        // valor_unitario: item['vl_unit_atualizado'] !== undefined ? item['vl_unit_atualizado'] : ciMatch.vl_unit_atualizado,
                        // contrato_item: ciMatch
                      // });
                    // }
                  // } else {
                    // Proponente sem contrato, usa o memorial apenas para popular a tela
                    remanejoNovo.itens.push({
                      quantidade: 0,
                      saldo: item['saldo_qtd'],
                      valor_unitario: item['vl_unit_atualizado'],
                      contrato_item: item
                    });
                  // }
                }

                // Adiciona o remanejo (com itens) na lista
                if (remanejoNovo.itens.length > 0) {
                  this.listaRemanejo.push(remanejoNovo);
                }
              }
              this.listaRemanejo = [...this.listaRemanejo];
              this.listaRemanejo.sort((a, b) => a.proponente.favorecido.nome.localeCompare(b.proponente.favorecido.nome));
            }

            // Sempre abre o dialog — mesmo com lista vazia, o usuário pode adicionar proponentes manualmente
            $('#dialogRemanejo').modal('show');
          });
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licitacao && this.licitacao?.id) {
      // Impede loop infinito verificando se é a mesma licitação antes de recarregar
      if (!changes.licitacao.previousValue || changes.licitacao.previousValue.id !== changes.licitacao.currentValue.id) {
        this.ordernarLista(null);
      }
    }
    if (changes.lista && this.lista) {
      this.lista = this.lista.sort((a, b) => +new Date(a.data_remanejo) - +new Date(b.data_remanejo));
    }
  }

  public verificarSaldoBotao() {
    if (!this.licitacao?.id) return false;
    const valorTotal = this.licitacao.itens?.reduce((soma, item) => soma + item['saldo_qtd'], 0);
    return valorTotal <= 0;
  }

  public ordernarLista(event: any) {
    this.remanejoService.filtrar(1, -1, {
      'licitacao.id': this.licitacao.id,
      relations: 'usuario,itens.contrato_item.produto_unidade.produto,proponente.favorecido',
      orderBy: 'data_remanejo$DESC'
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content;
      });

    // Recarregar contratos da licitação para atualizar a aba Contratos (Pendentes)
    // Dispara apenas quando for uma requisição via UI (event não for nulo) pra evitar o loop
    if (event) {
      this.contratoService.obterPorLicitacao(this.licitacao.id, this.login.orgao.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resContratos) => {
          if (resContratos?.content) {
            // Cria uma nova referência para forçar o disparo do ngOnChanges na aba de Contratos
            this.licitacao = { ...this.licitacao, contratos: resContratos.content } as Licitacao;
            this.licitacaoChange.emit(this.licitacao);
          }
        });
    }
  }

  public editar(item: ContratoRemanejo) {
    this.visualizar_item = false;
    this.itemAtual = item;
    this.itemAtual.data_remanejo = new DateFormatPipe().transform(item.data_remanejo, []);
    this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
    this.itemAtual.itens.map(itm => {
      itm.contrato_item['cota'] = this.retornaCota(itm, item.itens) === 'P' ? 'PRINCIPAL' : 'RESERVADO';
    });
    $('#dialogRemanejo').modal('show');
  }

  public visualizar(item: ContratoRemanejo) {
    this.itemAtual = { ...item };

    this.itemAtual.data_remanejo = new DateFormatPipe().transform(item.data_remanejo, []);
    this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
    this.visualizar_item = true;
    $('#dialogRemanejo').modal('show');
  }

  public condicaoEdicao(item: ContratoRemanejo): Boolean {
    if (!item.data_contabilizacao) return true;

    const diasBloqueio = this.login.parametro.contabil?.dias_bloquear_alteracoes;
    const dataAudesp = this.login.ultimoAudesp;
    const dataContabilizacao = this.funcaoService.zerarHoras(new Date(item.data_contabilizacao));
    const dataLimiteSuperior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()));
    const dataLimiteInferior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()), false, true);

    if (dataContabilizacao >= dataLimiteSuperior || dataContabilizacao <= dataLimiteInferior) {
      return false;
    }

    const mes = +dataAudesp.split('-')[1];
    const ano = +dataAudesp.split('-')[0];

    if ((dataContabilizacao.getFullYear() < ano || (dataContabilizacao.getFullYear() === ano && (+dataContabilizacao.getMonth() + 1) <= mes)) && mes < 12) {
      return false;
    }
    return true;
  }

  public retornaCota(itemAtual: ContratoRemanejoItem, lista: ContratoRemanejoItem[]): 'P' | 'R' {
    if (itemAtual.contrato_item.memorial) {
      return itemAtual.contrato_item.memorial.cota === 'RESERVADO' ? 'R' : 'P';
    }
    const itemIgual = lista.find(it => it.contrato_item.produto_unidade.id === itemAtual.contrato_item.produto_unidade.id && it.id !== itemAtual.contrato_item.id);
    return !itemIgual ? 'P' : +itemAtual.contrato_item.quantidade > +itemIgual.contrato_item.quantidade ? 'P' : 'R';
  }
}